// German translation file
export default {
  // Locale code for date formatting
  locale: "de-DE",
  
  // Homepage
  home: {
    hero: {
      title: "Kurs-Bewertungs-Hub",
      subtitle:
        "Neues Semester startet?\nUnsicher welche Kurse du wählen sollst?\nSchau dir hier an, was alle denken!",
      browseCourses: "Kurse durchsuchen",
      registerNow: "100% Kostenlos Anmelden",
    },
    stats: {
      courses: "Kurse",
      reviews: "Bewertungen",
      users: "Benutzer",
    },
    userJourney: {
      title: "Deine Reise beginnt hier",
      subtitle:
        "Befolge diese einfachen Schritte, um das Beste aus KursKompass herauszuholen und deine perfekten Kurse zu finden",
      premiumOffer: {
        title: "🎁 Eine Bewertung schreiben, 30 Tage gratis Zugang!",
        description:
          "Jede Bewertung gibt dir 30 Tage unbegrenzten Zugang - bleib aktiv, bleib für immer kostenlos!",
      },
      step1: {
        title: "Der Community beitreten",
        description:
          "Erstelle dein Konto, um alle Funktionen freizuschalten und dich mit Kommilitonen zu vernetzen - völlig kostenlos!",
        action: "100% Kostenlos Anmelden",
      },
      step2: {
        title: "Kurse durchsuchen",
        description:
          "Durchsuche tausende von Kursen deutscher Universitäten mit leistungsstarken Suchfiltern",
        action: "Kurse durchsuchen",
      },
      step3: {
        title: "Echte Bewertungen lesen",
        description:
          "Erhalte ehrliche Einblicke von Studenten, die tatsächlich die Kurse besucht haben, die du in Betracht ziehst",
        limitNote:
          "⚠️ Begrenzt auf 10 Bewertungen ohne Beitrag - Schreibe Bewertungen für unbegrenzten Zugang",
        action: "Bewertungen",
      },
      step4: {
        title: "Teilen & 30 Tage gratis erhalten",
        description:
          "Jede Bewertung gibt dir 30 Tage unbegrenzten Zugang - schreibe regelmäßig, um für immer kostenlos zu bleiben!",
        benefit: "30 Tage pro Bewertung",
        action: "Bewertung schreiben",
      },
      demo: {
        title: "Sieh wie es funktioniert",
      },
    },
    features: {
      title: "Warum KursKompass wählen?",
      subtitle:
        "Alles was du brauchst für fundierte Kursentscheidungen, an einem Ort",
      authentic: {
        title: "Authentische Bewertungen",
        description:
          "Kursbewertungen von echten Studenten, um die tatsächliche Kurserfahrung zu verstehen",
      },
      search: {
        title: "Intelligente Suche",
        description:
          "Leistungsstarke Suchfunktion, um schnell die benötigten Kursinformationen zu finden",
      },
      analysis: {
        title: "Datenanalyse",
        description:
          "Detaillierte Statistiken und Diagramme für fundierte Kurswahl-Entscheidungen",
      },
      community: {
        title: "Aktive Gemeinschaft",
        description:
          "Schließe dich tausenden von Studenten an, die Wissen teilen und sich gegenseitig beim Erfolg helfen",
      },
    },
    popularCourses: {
      title: "Beliebte Kurse",
      reviewsLabel: "Bewertungen",
      noData: "Keine beliebten Kursdaten verfügbar",
    },
    quickStart: {
      title: "Schnellstart",
      step1: {
        title: "Konto erstellen",
        description:
          "Erstellen Sie Ihr persönliches Konto, um die Plattform-Features zu nutzen",
        action: "Jetzt registrieren",
      },
      step2: {
        title: "Kurse durchsuchen",
        description:
          "Schauen Sie sich Universitäts- und Kurslisten an, um interessante Kurse zu finden",
        action: "Kurse durchsuchen",
      },
      step3: {
        title: "Bewertungen lesen",
        description:
          "Lesen Sie Kursbewertungen anderer Studenten, um Kursdetails zu verstehen",
        action: "Statistiken ansehen",
      },
      step4: {
        title: "Erfahrungen teilen",
        description: "Bewerten Sie Ihre Kurse, um anderen Studenten zu helfen",
        action: "Mit Bewertung beginnen",
      },
    },
  },

  // Common
  common: {
    search: "Suchen",
    login: "Anmelden",
    logout: "Abmelden",
    register: "Registrieren",
    submit: "Absenden",
    cancel: "Abbrechen",
    save: "Speichern",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirm: "Bestätigen",
    loading: "Wird geladen...",
    success: "Erfolgreich",
    error: "Fehler",
    warning: "Warnung",
    info: "Information",
    home: "Startseite",
    back: "Zurück",
    next: "Weiter",
    previous: "Vorherige",
    yes: "Ja",
    no: "Nein",
    active: "Aktiv",
    notAvailable: "Nicht verfügbar",
    close: "Schließen",
    footerDescription: "Deutsche Universitäts-Kursbewertungsplattform",
    showLess: "Weniger anzeigen",
    readMore: "Mehr lesen",
    skipForNow: "Jetzt überspringen",
    bookmarked: "Gespeichert",
    remove: "Entfernen",
    anonymousUser: "Anonymer Benutzer",
    retry: "Erneut versuchen",
    retrySuccess: "Erneuter Versuch erfolgreich",
    retryFailed: "Erneuter Versuch fehlgeschlagen, bitte versuchen Sie es später erneut",
    backToHome: "Zurück zur Startseite",
    since: "Seit",
    today: "Heute",
    yesterday: "Gestern",
    daysAgo: "vor {days} Tagen",
    loadError: "Fehler beim Laden der Daten",
  },

  // Navigation
  nav: {
    home: "Startseite",
    courses: "Kurse",
    universities: "Universitäten",
    reviews: "Bewertungen",
    recommendations: "Empfehlungen",
    stats: "Statistiken",
    trending: "Trending",
    profile: "Profil",
    settings: "Einstellungen",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    addCourse: "Kurs hinzufügen",
    about: "Über uns",
    myInvitationCode: "Mein Einladungscode",
    cancel: "Abbrechen",
    logoutConfirmMessage: "Möchten Sie sich wirklich abmelden?",
    logoutConfirmTitle: "Abmeldebestätigung",
    logoutConfirm: "Abmelden",
    logoutSuccess: "Erfolgreich abgemeldet",
  },

  // Trending Page
  trending: {
    subtitle: "Entdecke die beliebtesten und bestbewerteten Kurse an deiner Universität",
    topRated: "Bestbewertete Kurse",
    mostReviewed: "Meist bewertete Kurse",
    avgRatingSort: "Sortiert nach Durchschnittsbewertung",
    reviewCountSort: "Sortiert nach Anzahl der Bewertungen",
    noData: "Noch keine Kurse verfügbar",
    noUniversity: "Keine Universität ausgewählt",
    noUniversityDesc: "Bitte wähle deine Universität in deinem Profil aus, um Trending-Kurse anzuzeigen",
    pleaseSelectUniversity: "Bitte wähle zuerst eine Universität aus",
  },

  // Authentication
  auth: {
    loginNow: "Jetzt anmelden",
    hasAccount: "Bereits ein Konto?",
    noAccount: "Noch kein Konto?",
    username: "Benutzername",
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    registerTitle: "Werde Teil der schlauen Kurswähler",
    registerSubtitle: "Wähle nicht blind - lass unsere Community dein Wegweiser sein!",
    loginTitle: "Anmelden",
    login: {
      title: "Anmelden",
      welcomeBack: "Willkommen zurück",
      subtitle: "Melden Sie sich bei Ihrem KursKompass-Konto an",
      username: "Benutzername",
      password: "Passwort",
      usernamePlaceholder: "Benutzername oder E-Mail",
      passwordPlaceholder: "Passwort",
      loginButton: "Anmelden",
      rememberMe: "Angemeldet bleiben",
      forgotPassword: "Passwort vergessen?",
      noAccount: "Noch kein Konto?",
      registerNow: "Jetzt registrieren",
      platformTitle: "Deutsche Universitäts-Kursbewertungsplattform",
      platformDescription:
        "Transparente und authentische Kursbewertungen, um bessere Kurswahl-Entscheidungen zu treffen",
      features: {
        authentic: "Authentische Bewertungen",
        search: "Intelligente Suche",
        analysis: "Datenanalyse",
      },
      loginSuccess: "Erfolgreich angemeldet",
      loginFailed: "Anmeldung fehlgeschlagen",
      emailVerifiedSuccess:
        "E-Mail erfolgreich verifiziert! Sie können sich jetzt anmelden.",
      emailVerificationFailed:
        "E-Mail-Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      emailNotVerifiedTitle: "E-Mail nicht verifiziert",
      emailNotVerifiedMessage:
        "Ihre E-Mail ist noch nicht verifiziert. Bitte verifizieren Sie Ihre E-Mail vor der Anmeldung. Möchten Sie die Verifizierungs-E-Mail erneut senden?",
      resendButton: "Erneut senden",
      laterButton: "Später",
      validationError:
        "Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut",
      validation: {
        usernameRequired: "Bitte geben Sie Benutzername oder E-Mail ein",
        usernameLength:
          "Benutzername/E-Mail Länge sollte zwischen 3 und 50 Zeichen liegen",
        passwordRequired: "Bitte geben Sie das Passwort ein",
        passwordLength: "Passwort sollte nicht weniger als 6 Zeichen haben",
      },
    },
    forgotPassword: {
      title: "Passwort vergessen",
      subtitle: "Geben Sie Ihre E-Mail-Adresse ein und wir helfen Ihnen, Ihr Passwort zurückzusetzen",
      emailPlaceholder: "Geben Sie Ihre E-Mail ein",
      submitButton: "Anweisungen senden",
      backToLogin: "Zurück zur Anmeldung",
      successMessage: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie in Kürze Anweisungen zum Zurücksetzen des Passworts.",
      infoTitle: "Passwort-Zurücksetzen Information",
      infoMessage: "Derzeit befindet sich die Funktion zum Zurücksetzen des Passworts in der Entwicklung. Bitte kontaktieren Sie den Support, wenn Sie Ihr Passwort zurücksetzen müssen.",
      validation: {
        emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein",
        emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      },
    },
    register: {
      title: "Werde Teil der schlauen Kurswähler",
      subtitle:
        "Wähle nicht blind - lass unsere Community dein Wegweiser sein!",
      username: "Benutzername",
      email: "E-Mail",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      invitationCode: "Einladungscode (Optional)",
      invitationCodeHint: "Hast du einen Einladungscode? Gib ihn ein, um 1 Jahr Premium-Zugang für dich und deinen Freund zu erhalten!",
      validate: "Validieren",
      validating: "Validiere...",
      hasAccount: "Bereits ein Konto?",
      loginNow: "Jetzt anmelden",
    },
  },

  // Search
  search: {
    title: "Suche",
    placeholder: "Kurse, Universitäten suchen...",
    searchResults: "Suchergebnisse",
    noResults: "Keine Ergebnisse gefunden",
    popularSearches: "Beliebte Suchen",
    pleaseEnterSearchTerm: "Bitte Suchbegriff eingeben",
    searchFor: "Suchen nach",
    filterByType: "Nach Typ filtern",
    filterByUniversity: "Nach Universität filtern",
    sortBy: "Sortieren nach",
    relevance: "Relevanz",
    newest: "Neueste",
    oldest: "Älteste",
    rating: "Bewertung",
    name: "Name",
    results: "Ergebnisse",
    found: "gefunden",
    suggestions: "Vorschläge",
    history: "Suchverlauf",
    clearHistory: "Verlauf löschen",
    course: "Kurs",
    university: "Universität",
    courseCode: "Kurscode",
    other: "Andere",
  },

  // Courses
  courses: {
    title: "Kurse",
    subtitle: "Echte Studenten, echte Bewertungen, echte kluge Entscheidungen",
    search: "Kurse suchen...",
    filters: {
      university: "Universität",
      semester: "Semester",
      all: "Alle",
    },
    details: {
      code: "Kurscode",
      description: "Beschreibung",
      university: "Universität",
      semester: "Semester",
      reviews: "Bewertungen",
      rating: "Bewertung",
      similarCourses: "Ähnliche Kurse",
    },
    noResults: "Keine Kurse gefunden",
    loading: "Kurse werden geladen...",
  },

  // Add Course
  addCourse: {
    title: "Kurs hinzufügen",
    subtitle: "Kurs nicht gefunden? Füge ihn hinzu und schreibe die erste Bewertung!",
    form: {
      university: "Universität",
      universityPlaceholder: "Universität auswählen",
      courseName: "Kursname",
      courseNamePlaceholder: "z.B. Einführung in die Informatik",
      courseCode: "Kurscode",
      courseCodePlaceholder: "z.B. CS101, MATH200",
      department: "Fakultät (Optional)",
      departmentPlaceholder: "z.B. Informatik, Mathematik",
      credits: "Credits (Optional)",
      level: "Level (Optional)",
      levelPlaceholder: "Level auswählen",
      levelBachelor: "Bachelor",
      levelMaster: "Master",
      levelPhD: "PhD",
    },
    actions: {
      cancel: "Abbrechen",
      submit: "Kurs hinzufügen & erste Bewertung schreiben",
    },
    messages: {
      selectUniversity: "Bitte wählen Sie eine Universität aus",
      loadUniversitiesFailed: "Fehler beim Laden der Universitäten",
      addSuccess: "Kurs erfolgreich hinzugefügt! Jetzt schreibe deine Bewertung.",
      addFailed: "Fehler beim Hinzufügen des Kurses",
      duplicateCourse: "Dieser Kurs existiert bereits! Weiterleitung zum vorhandenen Kurs...",
    },
  },

  // Universities
  universities: {
    title: "Universitäten",
    subtitle: "Alle deutschen Universitäten durchsuchen",
    name: "Universitätsname",
    location: "Standort",
    city: "Stadt",
    state: "Bundesland",
    established: "Gegründet",
    type: "Typ",
    ranking: "Ranking",
    website: "Webseite",
    description: "Beschreibung",
    students: "Studenten",
    faculty: "Fakultät",
    programs: "Programme",
    tuition: "Studiengebühren",
    admissionRate: "Zulassungsrate",
    graduationRate: "Abschlussrate",
    search: "Universitäten suchen...",
    searchPlaceholder: "Nach Universitätsname suchen...",
    cityPlaceholder: "Stadt wählen",
    statePlaceholder: "Bundesland wählen",
    filterByType: "Nach Typ filtern",
    filterByLocation: "Nach Standort filtern",
    filterByRanking: "Nach Ranking filtern",
    public: "Öffentlich",
    private: "Privat",
    technical: "Technisch",
    liberal: "Geisteswissenschaften",
    research: "Forschung",
    comprehensive: "Umfassend",
    viewDetails: "Details ansehen",
    viewCourses: "Kurse ansehen",
    moreInfo: "Mehr Informationen",
    contact: "Kontakt",
    apply: "Bewerben",
    favorites: "Favoriten",
    addToFavorites: "Zu Favoriten hinzufügen",
    removeFromFavorites: "Aus Favoriten entfernen",
    compare: "Vergleichen",
    addToCompare: "Zum Vergleich hinzufügen",
    removeFromCompare: "Aus Vergleich entfernen",
    clearFilters: "Filter zurücksetzen",
    searchButton: "Suchen",
    coursesAvailable: "{count} Kurse verfügbar",
    coursesAvailableSingular: "{count} Kurs verfügbar",
    noData: "Keine Universitätsdaten verfügbar",
    showingResults: "{count} Universitäten anzeigen",
    showingResultsSingular: "{count} Universität anzeigen",
    details: {
      name: "Name",
      totalCourses: "Kurse insgesamt",
    },
    noResults: "Keine Universitäten gefunden",
    loading: "Universitäten werden geladen...",
  },

  // University Selection
  university: {
    selectYourUniversity: "Wähle deine Universität",
    searchPlaceholder: "Suche nach Name, Stadt oder Abkürzung (z.B. TUM, RWTH, LMU)...",
    searchHint: "💡 Probiere Abkürzungen wie TUM, RWTH, KIT oder FH",
    selectionHint:
      "Bitte wähle deine Universität aus. Dies hilft uns, dir relevante Kurse anzuzeigen.",
    coursesAvailable: "{count} Kurse verfügbar",
    noResults: "Keine Universitäten gefunden",
    fetchError: "Fehler beim Laden der Universitäten",
    selectionSuccess: "Universität erfolgreich ausgewählt",
    selectionFailed: "Fehler beim Auswählen der Universität",
    skipForNow: "Später auswählen",
  },

  // University Switcher
  universitySwitcher: {
    selectUniversity: "Universität wählen",
    searchPlaceholder: "Suchen...",
    current: "Aktuelle Universität",
    switchTo: "Wechseln zu",
    viewAll: "Alle Universitäten anzeigen",
    clearSelection: "Auswahl aufheben",
    noResults: "Keine Universitäten gefunden",
  },

  // Reviews
  reviews: {
    title: "Bewertungen",
    subtitle:
      "Ist dieser Kurs es wert? Wie ist der Professor? Viel Arbeitsaufwand? Finde es hier heraus!",
    write: "Bewertung schreiben",
    noCourseReviews: "Keine Bewertungen für diesen Kurs gefunden",
    beFirstToReview: "Sei die erste Person, die eine Bewertung schreibt",
    rating: "Bewertung",
    comment: "Kommentar",
    submit: "Bewertung absenden",
    edit: "Bewertung bearbeiten",
    delete: "Bewertung löschen",
    confirmDelete: "Möchten Sie diese Bewertung wirklich löschen?",
    helpful: "Hilfreich",
    notHelpful: "Nicht hilfreich",
    wasHelpful: "War diese Bewertung hilfreich?",
    loginToVote: "Anmelden zum Abstimmen",
    professorStyle: "Professoren-Stil",
    selectProfessorTags:
      "Wählen Sie Professoren-Stil-Tags, die Ihrer Erfahrung entsprechen",
    professorTags: "Professoren-Tags",
    professorTagsDescription:
      "Bitte wählen Sie Tags, die basierend auf Ihrer Erfahrung am besten zu diesem Professor passen",
    selectedTags: "Ausgewählte Tags ({count})",
    // Reply functionality
    reply: "Antworten",
    replies: "Antworten",
    repliesCount: "{count} Antworten",
    replyPlaceholder: "Schreiben Sie eine Antwort...",
    submitReply: "Antwort senden",
    replySubmitted: "Antwort erfolgreich gesendet",
    replyFailed: "Antwort konnte nicht gesendet werden",
    replyUpdated: "Antwort erfolgreich aktualisiert",
    replyUpdateFailed: "Aktualisierung der Antwort fehlgeschlagen",
    pleaseEnterReply: "Bitte geben Sie eine Antwort ein",
    showMoreReplies: "Weitere Antworten anzeigen",
    deleteReply: "Antwort löschen",
    confirmDeleteReply:
      "Sind Sie sicher, dass Sie diese Antwort löschen möchten?",
    sendMessage: "Nachricht senden",
    // Anonymous posting
    postAnonymously: "Anonym posten",
    anonymousTooltip: "Ihr Benutzername wird vor anderen Benutzern verborgen",
    // Vote related
    thankYou: "Danke für Ihr Feedback!",
    thankYouPositive: "Danke für Ihr positives Feedback!",
    voteCanceled: "Abstimmung wurde zurückgezogen",
    voteFailed: "Abstimmung fehlgeschlagen",
    cannotVoteOwnReview: "Sie können nicht für Ihre eigene Bewertung abstimmen",
    youFoundThisReview: "Sie fanden diese Bewertung",
    voteHelpful: "hilfreich",
    voteNotHelpful: "nicht hilfreich",
    // Deleted review
    deletedTitle: "Diese Bewertung wurde vom Benutzer gelöscht",
    deletedSubtitle: "Antworten auf diese Bewertung sind weiterhin unten sichtbar",
    stats: {
      average: "Durchschnitt",
      total: "Bewertungen insgesamt",
      distribution: "Verteilung",
    },
    noReviews: "Noch keine Bewertungen",
    loading: "Bewertungen werden geladen...",
    accessControl: {
      limitedCardTitle: "Begrenzter Zugriff",
      limitReachedCardTitle: "Bewertungs-Limit erreicht",
      limitAlertTitle: "Begrenzter Zugriff aktiv",
      limitReachedAlertTitle: "Limit erreicht",
      limitAlertDescription:
        "Du kannst bis zu {limit} Bewertungen ohne eigenen Beitrag ansehen. Verbleibende freie Ansichten: {remaining}.",
      limitReachedDescription:
        "Du hast alle {limit} frei verfügbaren Bewertungen gelesen. Schreibe eine Bewertung, um mehr freizuschalten.",
      unlockTitle: "🚀 Vollzugriff freischalten",
      unlockWriteReviewTitle: "Bewertung verfassen",
      unlockWriteReviewDescription:
        "Teile deine Kurserfahrung und erhalte 30 Tage unbegrenzten Zugriff!",
      writeReviewCta: "Bewertung schreiben",
      statusTitle: "Aktueller Status",
      reviewsViewedLabel: "Gelesene Bewertungen",
      reviewsWrittenLabel: "Eigene Bewertungen",
      remainingReviewsLabel: "Verbleibende freie Bewertungen",
      premiumCardTitle: "Premium-Zugang aktiv",
      premiumAlertTitle: "Unbegrenzter Zugriff",
      premiumAlertDescription:
        "Du hast unbegrenzten Zugriff auf alle Bewertungen!",
      premiumValidUntil: "Gültig bis",
      premiumReviewedThisMonth: "Bewertung diesen Monat abgegeben",
      premiumTotalReviews: "Bewertungen insgesamt",
      encourageCardTitle: "Erfahrung teilen",
      encourageDescription:
        "Hilf anderen Studierenden, indem du deine Kurserfahrung teilst!",
      encourageCta: "Jetzt erste Bewertung schreiben",
    },
    progressiveLoading: {
      showMore: "Weitere Bewertungen anzeigen",
      showMoreCount: "({current}/{total})",
      loadHint: "Zeigt jeweils 1 Bewertung an",
      limitReached: "Bewertungs-Anzeigelimit erreicht",
      youViewed: "Sie haben <strong>{count}</strong> Bewertungen angesehen (Limit: {limit})",
      unlockRemaining: "<strong>{count}</strong> Bewertungen noch freizuschalten",
      unlockWriteTitle: "Durch Bewertung freischalten",
      unlockWriteDesc: "Schreibe eine Kursbewertung und schalte 30 Tage unbegrenzten Zugriff frei",
      writeNowBtn: "Jetzt Bewertung schreiben",
      freeBadge: "Kostenlos · Stapelbar",
      or: "ODER",
      unlockInviteTitle: "Durch Freundeseinladung freischalten",
      unlockInviteDesc: "Lade einen Freund ein, sich zu registrieren und eine Bewertung zu schreiben - ihr beide erhaltet 1 Jahr Mitgliedschaft",
      getInviteCodeBtn: "Einladungscode erhalten",
      stackableInfo: "Beide Methoden sind stapelbar, Freischaltungstage addieren sich",
    },
  },

  // Recommendations
  recommendations: {
    title: "Empfehlungen",
    subtitle:
      "Schließe dich tausenden Studenten an, die klügere Kursentscheidungen treffen",
    // Header
    smartRecommendations: "Intelligente Empfehlungen",
    aiPoweredSubtitle: "KI-gestützte Kursvorschläge speziell für dich",
    recommendationSettings: "Empfehlungseinstellungen",
    refreshAll: "Alle aktualisieren",
    
    // Engine Status
    recommendationEngine: "Empfehlungs-Engine",
    engineDescription: "KI-Modell trainiert mit {count} Nutzerinteraktionen • Letztes Update: {date}",
    accuracy: "Genauigkeit",
    confidence: "Konfidenz",
    
    // Personalized Section
    personalizedForYou: "Personalisiert für dich",
    courses: "Kurse",
    relevance: "Relevanz",
    rating: "Bewertung",
    difficulty: "Schwierigkeit",
    
    // Sorting
    sortByRelevance: "Nach Relevanz sortieren",
    sortByRating: "Nach Bewertung sortieren",
    sortByDifficulty: "Nach Schwierigkeit sortieren",
    
    // Login Required State
    signInForPersonalized: "Anmelden für personalisierte Empfehlungen",
    signInDescription: "Erhalte KI-gestützte Kursvorschläge, die auf deine Interessen, akademischen Hintergrund und Lernziele zugeschnitten sind.",
    signIn: "Anmelden",
    createAccount: "Konto erstellen",
    or: "oder",
    browsePopular: "Beliebte Kurse durchsuchen",
    
    // Login Benefits
    benefits: {
      smartAI: "Intelligente KI-Empfehlungen basierend auf deinem Profil",
      trackProgress: "Verfolge deinen Lernfortschritt und Präferenzen",
      discoverCourses: "Entdecke Kurse passend zu deinem Niveau",
    },
    
    // Trending Section
    trendingNow: "Aktuell im Trend",
    growth: "Wachstum",
    match: "Übereinstimmung",
    
    // Top Rated Section  
    topRated: "Top bewertet",
    reviews: "Bewertungen",
    
    // Because You Viewed Section
    becauseYouViewed: "Weil du angesehen hast",
    basedOnHistory: "Basierend auf deinem Browserverlauf",
    youViewed: "Du hast angesehen",
    similarCourses: "Ähnliche Kurse",
    viewDetails: "Details ansehen",
    excellentMatch: "Ausgezeichnete Übereinstimmung",
    greatMatch: "Gute Übereinstimmung",
    goodMatch: "Passende Übereinstimmung",
    
    // Settings Dialog
    settings: {
      title: "Empfehlungseinstellungen",
      focus: "Empfehlungsfokus",
      balanced: "Ausgewogen",
      popular: "Beliebte Kurse",
      challenging: "Herausfordernde Kurse",
      easy: "Einfache Kurse",
      difficultyPreference: "Schwierigkeitspräferenz",
      difficultyLevels: {
        easy: "Einfach",
        medium: "Mittel",
        hard: "Schwer",
      },
      subjectInterests: "Fachinteressen",
      subjects: {
        computerScience: "Informatik",
        mathematics: "Mathematik",
        engineering: "Ingenieurwesen",
        business: "Wirtschaft",
        languages: "Sprachen",
      },
      cancel: "Abbrechen",
      save: "Einstellungen speichern",
      saved: "Einstellungen gespeichert",
    },
    
    // Empty States
    noPersonalizedRecommendations: "Keine personalisierten Empfehlungen verfügbar",
    explorePopularCourses: "Beliebte Kurse entdecken",
    
    // Success Messages
    allRecommendationsRefreshed: "Alle Empfehlungen aktualisiert",
    recommendationDismissed: "Empfehlung verworfen",
    addedToWishlist: "Kurs zur Wunschliste hinzugefügt!",
    
    // Legacy translations (keep for backward compatibility)
    personal: {
      title: "Persönliche Empfehlungen",
      description: "Basierend auf Ihren Präferenzen und Bewertungen",
    },
    popular: {
      title: "Beliebte Kurse",
      description: "Derzeit am besten bewertete Kurse",
    },
    collaborative: {
      title: "Kollaborative Filterung",
      description: "Kurse, die Nutzer mit ähnlichen Interessen mögen",
    },
    similar: {
      title: "Ähnliche Kurse",
      description: "Kurse mit ähnlichen Inhalten",
    },
    algorithms: {
      title: "Unsere Empfehlungsalgorithmen",
      userPreference: {
        title: "Benutzerpräferenz-Analyse",
        description:
          "Analysiert Ihre Bewertungshistorie, um Ihre bevorzugten Kurstypen und Universitäten zu identifizieren.",
      },
      collaborative: {
        title: "Kollaborative Filterung",
        description:
          "Empfiehlt Kurse basierend auf den Bewertungen ähnlicher Benutzer.",
      },
      content: {
        title: "Inhaltsbasierte Filterung",
        description:
          "Findet Kurse mit ähnlichen Beschreibungen und Eigenschaften.",
      },
      popularity: {
        title: "Popularitätsbasiert",
        description:
          "Hebt die aktuell beliebtesten und am besten bewerteten Kurse hervor.",
      },
    },
    loginRequired:
      "Bitte melden Sie sich an, um personalisierte Empfehlungen zu erhalten",
    noRecommendations: "Keine Empfehlungen verfügbar",
    loading: "Empfehlungen werden geladen...",
  },

  // Statistics
  stats: {
    title: "Statistiken",
    global: "Globale Statistiken",
    overview: {
      totalCourses: "Kurse insgesamt",
      totalUniversities: "Universitäten insgesamt",
      totalReviews: "Bewertungen insgesamt",
      averageRating: "Durchschnittsbewertung",
    },
    topCourses: "Top Kurse",
    topUniversities: "Top Universitäten",
    loading: "Statistiken werden geladen...",
  },

  // Error messages
  errors: {
    network: "Netzwerkverbindung fehlgeschlagen",
    server: "Serverfehler",
    notFound: "Seite nicht gefunden",
    unauthorized: "Keine Berechtigung",
    validation: "Eingabedaten ungültig",
    generic: "Ein unerwarteter Fehler ist aufgetreten",
    // Error Boundary
    defaultTitle: "Ein Problem ist aufgetreten",
    defaultMessage: "Das System ist auf einen unerwarteten Fehler gestoßen, bitte versuchen Sie es später erneut",
    networkTitle: "Netzwerkverbindungsproblem",
    networkMessage: "Kann keine Verbindung zum Server herstellen, bitte prüfen Sie Ihre Netzwerkverbindung",
    notFoundTitle: "Seite nicht gefunden",
    notFoundMessage: "Die angeforderte Ressource existiert nicht, sie wurde möglicherweise verschoben oder gelöscht",
    permissionTitle: "Keine Berechtigung",
    permissionMessage: "Sie haben keine Berechtigung für den Zugriff auf diese Ressource, bitte melden Sie sich erneut an",
  },

  // Success messages
  success: {
    loginSuccess: "Erfolgreich angemeldet",
    registerSuccess: "Registrierung erfolgreich",
    reviewSubmitted: "Bewertung erfolgreich abgesendet",
    reviewUpdated: "Bewertung erfolgreich aktualisiert",
    reviewDeleted: "Bewertung erfolgreich gelöscht",
  },

  // Validation messages
  validation: {
    required: "Dieses Feld ist erforderlich",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    minLength: "Mindestens {min} Zeichen erforderlich",
    maxLength: "Maximal {max} Zeichen erlaubt",
    passwordMatch: "Passwörter stimmen nicht überein",
    rating: "Bitte wählen Sie eine Bewertung zwischen 1 und 5",
  },

  // Date and time
  date: {
    today: "Heute",
    yesterday: "Gestern",
    thisWeek: "Diese Woche",
    thisMonth: "Diesen Monat",
    daysAgo: "vor {count} Tag | vor {count} Tagen",
    weeksAgo: "vor {count} Woche | vor {count} Wochen",
    monthsAgo: "vor {count} Monat | vor {count} Monaten",
    semester: {
      WS: "Wintersemester",
      SS: "Sommersemester",
    },
  },

  // Theme
  theme: {
    switchToLight: "Zum hellen Modus wechseln",
    switchToDark: "Zum dunklen Modus wechseln",
    lightMode: "Heller Modus",
    darkMode: "Dunkler Modus",
  },

  // Pagination
  pagination: {
    total: "Insgesamt {total} Einträge",
    page: "Seite {current} von {total}",
    itemsPerPage: "Einträge pro Seite",
    goTo: "Gehe zu",
    prev: "Vorherige",
    next: "Nächste",
  },

  // About page
  about: {
    title: "Über KursKompass",
    subtitle:
      "Wir befähigen Studenten, fundierte Kursentscheidungen durch gemeinschaftsgetriebene Bewertungen zu treffen",
    story: {
      title: "Unsere Geschichte",
      paragraph1:
        "KursKompass entstand aus einer einfachen, aber mächtigen Idee: Studenten verdienen transparente, authentische Informationen über ihre Kurse, bevor sie wichtige akademische Entscheidungen treffen.",
      paragraph2:
        "Als Studenten selbst erlebten wir die Frustration, Kurse blind zu wählen, nur um später festzustellen, dass der Lehrstil, die Arbeitsbelastung oder der Inhalt nicht unseren Erwartungen entsprach. Wir erkannten, dass die kollektive Weisheit der Studentengemeinschaft dieses Problem lösen könnte.",
      paragraph3:
        "Heute dient KursKompass tausenden von Studenten an deutschen Universitäten und hilft ihnen, klügere Kursentscheidungen zu treffen und bessere akademische Laufbahnen aufzubauen. Unsere Plattform entwickelt sich kontinuierlich basierend auf Community-Feedback und -Bedürfnissen weiter.",
    },
    mission: {
      title: "Unsere Mission",
      transparency: {
        title: "Transparenz zuerst",
        description:
          "Wir glauben, dass jeder Student ehrliche, ungefilterte Einblicke in Kurse und Professoren verdient, bevor er akademische Verpflichtungen eingeht.",
      },
      community: {
        title: "Gemeinschaftsgetrieben",
        description:
          "Unsere Plattform gedeiht durch Studentenbeiträge und schafft ein unterstützendes Ökosystem, in dem Wissen und Erfahrungen frei geteilt werden.",
      },
      improvement: {
        title: "Kontinuierliche Verbesserung",
        description:
          "Wir entwickeln unsere Plattform kontinuierlich basierend auf Nutzerfeedback weiter und stellen sicher, dass wir den sich wandelnden Bedürfnissen der akademischen Gemeinschaft gerecht werden.",
      },
    },
    contact: {
      title: "Kontakt aufnehmen",
      description:
        "Haben Sie Vorschläge, Feedback oder Ideen, um KursKompass zu verbessern? Wir würden gerne von Ihnen hören! Ihr Input hilft uns, eine Plattform zu schaffen, die der Studentengemeinschaft wirklich dient.",
      email: {
        title: "E-Mail an uns",
      },
      feedback: {
        title: "Feedback teilen",
        description:
          "Helfen Sie uns, uns zu verbessern, indem Sie Ihre Gedanken und Vorschläge teilen",
      },
      sendFeedback: "Feedback senden",
    },
    feedback: {
      title: "Senden Sie uns Feedback",
      type: "Typ",
      subject: "Betreff",
      message: "Nachricht",
      email: "E-Mail (optional)",
      subjectPlaceholder: "Kurze Zusammenfassung Ihres Feedbacks",
      messagePlaceholder:
        "Erzählen Sie uns mehr über Ihre Gedanken, Vorschläge oder Probleme...",
      emailPlaceholder: "ihre.email{'@'}beispiel.de",
      types: {
        placeholder: "Feedback-Typ auswählen",
        suggestion: "Vorschlag",
        bug: "Fehlerbericht",
        feature: "Feature-Anfrage",
        general: "Allgemeines Feedback",
      },
      submitted:
        "Vielen Dank für Ihr Feedback! Wir werden Ihre Vorschläge sorgfältig prüfen.",
      successMessage:
        "Vielen Dank für Ihr Feedback! Wir schätzen Ihren Beitrag und werden ihn sorgfältig prüfen.",
      errorMessage:
        "Feedback konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
    },
  },

  // Footer
  footer: {
    quickLinks: "Schnellzugriff",
    features: "Funktionen",
    aboutContact: "Über uns & Kontakt",
    aboutUs: "Über uns",
    contact: "Kontakt",
    sendFeedback: "Feedback senden",
    privacy: "Datenschutz",
    professorProfiles: "Professoren-Insights",
    advancedSearch: "Erweiterte Suche",
    allRightsReserved: "Alle Rechte vorbehalten.",
  },

  // Lesezeichen
  bookmarks: {
    bookmark: "Lesezeichen",
    bookmarked: "Gespeichert",
    addedSuccess: "Kurs erfolgreich gespeichert!",
    removedSuccess: "Lesezeichen erfolgreich entfernt!",
    alreadyBookmarked: "Kurs ist bereits gespeichert",
    error: "Fehler beim Aktualisieren des Lesezeichens",
    notes: "Notizen",
    notesPlaceholder:
      "Fügen Sie Ihre persönlichen Notizen zu diesem Kurs hinzu...",
    editNotes: "Notizen bearbeiten",
    notesUpdated: "Notizen erfolgreich aktualisiert!",
    notesError: "Fehler beim Aktualisieren der Notizen",
    removeBookmark: "Lesezeichen entfernen",
    contextMenuTitle: "Lesezeichen-Optionen",
    contextMenuMessage: "Was möchten Sie mit diesem Lesezeichen machen?",
    myBookmarks: "Meine Lesezeichen",
    noBookmarks: "Noch keine Lesezeichen",
    searchBookmarks: "Lesezeichen durchsuchen...",
    trendingBookmarks: "Beliebte Lesezeichen",
    stats: {
      total: "Gesamt Lesezeichen",
      recent: "Aktuelle Lesezeichen",
      categories: "Top Kategorien",
    },
  },

  // Folgen
  follows: {
    follow: "Folgen",
    following: "Folge ich",
    mutual: "Gegenseitig",
    unfollow: "Entfolgen",
    followedSuccess: "Sie folgen jetzt {username}!",
    unfollowedSuccess: "Sie folgen {username} nicht mehr",
    alreadyFollowing: "Sie folgen diesem Benutzer bereits",
    alreadyUnfollowed: "Sie folgen diesem Benutzer bereits nicht mehr",
    cannotFollowSelf: "Sie können sich nicht selbst folgen",
    error: "Fehler beim Aktualisieren des Folge-Status",
    user: "Benutzer",
    followers: "Follower",
    followersCount: "{count} Follower",
    followingCount: "{count} Folge ich",
    mutualFollows: "Gegenseitige Follows",
    recentFollowers: "Neue Follower",
    noFollowers: "Noch keine Follower",
    noFollowing: "Folgt noch niemandem",
    stats: {
      following: "Folge ich",
      followers: "Follower",
      mutual: "Gegenseitig",
    },
  },

  // Nachrichten
  messagesPage: {
    title: "Nachrichten",
    tabs: {
      inbox: "Posteingang",
      sent: "Gesendet",
    },
    empty: {
      noMessages: "Keine Nachrichten",
      noSentMessages: "Keine gesendeten Nachrichten",
    },
    actions: {
      markAsRead: "Als gelesen markieren",
      delete: "Löschen",
      compose: "Nachricht verfassen",
      send: "Senden",
      cancel: "Abbrechen",
      close: "Schließen",
      reply: "Antworten",
    },
    form: {
      receiver: "Empfänger",
      receiverPlaceholder: "Benutzer-ID eingeben",
      sendingTo: "Senden an:",
      subject: "Betreff",
      subjectPlaceholder: "Nachrichtenbetreff eingeben",
      message: "Nachricht",
      messagePlaceholder: "Ihre Nachricht eingeben",
      messageSimplePlaceholder: "Geben Sie hier Ihre Nachricht ein...",
    },
    dialog: {
      composeTitle: "Nachricht verfassen",
      composeToUser: "Nachricht an {username}",
      from: "Von:",
      to: "An:",
      date: "Datum:",
      read: "Gelesen:",
      sentAt: "Gesendet:",
      content: "Inhalt:",
    },
    confirm: {
      deleteTitle: "Löschen bestätigen",
      deleteMessage: "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
      deleteButton: "Löschen",
      cancelButton: "Abbrechen",
    },
    messages: {
      loadFailed: "Fehler beim Laden der Nachrichten",
      sendSuccess: "Nachricht erfolgreich gesendet",
      sendFailed: "Fehler beim Senden der Nachricht",
      markReadFailed: "Fehler beim Markieren der Nachricht als gelesen",
      markReadSuccess: "Nachricht als gelesen markiert",
      deleteSuccess: "Nachricht erfolgreich gelöscht",
      deleteFailed: "Fehler beim Löschen der Nachricht",
    },
  },

  // Einladungssystem
  invitation: {
    title: "Freunde einladen",
    subtitle: "Laden Sie einen Freund ein, und wenn er seine erste Bewertung schreibt, erhalten Sie beide 1 JAHR Premium-Zugang!",
    myCode: "Mein Einladungscode",
    yourCode: "Ihr einzigartiger Einladungscode",
    myCodeSubtitle: "Teilen Sie diesen permanenten Code mit unbegrenzten Freunden!",
    totalUses: "Gesamte Verwendungen",
    completedReviews: "Abgeschlossene Bewertungen",
    usageHistory: "Verwendungsverlauf",
    reviewStatus: "Bewertungsstatus",
    reviewed: "Bewertet",
    pending: "Ausstehend",
    reviewedAt: "Bewertet am",
    premiumStatus: "Premium-Status",
    granted: "Gewährt",
    generateCode: "Einladungscode generieren",
    generating: "Wird generiert...",
    myInvitations: "Meine Einladungscodes",
    code: "Code",
    statusLabel: "Status",
    createdAt: "Erstellt",
    usedAt: "Verwendet",
    invitee: "Eingeladener Benutzer",
    actions: "Aktionen",
    copyCode: "Code kopieren",
    share: "Teilen",
    shareCode: "Code teilen",
    copied: "In Zwischenablage kopiert!",
    generated: "Einladungscode erfolgreich generiert!",
    error: "Fehler beim Generieren des Einladungscodes",
    noInvitations: "Noch kein Einladungscode",
    codeInfo: "Dies ist Ihr permanenter Einladungscode. Teilen Sie ihn mit so vielen Freunden wie Sie möchten!",
    viewDetails: "Vollständige Details anzeigen",
    statusTypes: {
      pending: "Ausstehend",
      used: "Verwendet",
      completed: "Abgeschlossen (Premium gewährt)",
    },
    shareMessage: "Tritt KursKompass mit meinem Einladungscode bei: {code}\nWenn du deine erste Bewertung schreibst, bekommen wir beide 1 Jahr Premium-Zugang!",
    howItWorks: {
      title: "So funktioniert es",
      step1: "Ihr permanenter Einladungscode ist bereit zum Teilen",
      step2: "Teilen Sie ihn mit unbegrenzten Freunden",
      step3: "Wenn sie sich registrieren und ihre erste Bewertung schreiben",
      step4: "Sie beide erhalten 1 JAHR Premium-Zugang!",
    },
  },

  // Premium-Verlauf
  premium: {
    title: "Premium-Zugang Verlauf",
    subtitle: "Verfolgen Sie Ihre Premium-Zugang Gewährungen und Ablaufdaten",
    currentStatus: "Aktueller Status",
    active: "Aktives Premium",
    expired: "Abgelaufen",
    expiresOn: "Läuft ab am",
    expiredOn: "Abgelaufen am",
    history: "Zugangs-Verlauf",
    grantedAt: "Gewährt",
    duration: "Dauer",
    source: "Quelle",
    noHistory: "Noch kein Premium-Verlauf",
    noPremiumAccess: "Kein Premium-Zugang",
    noPremiumDescription: "Schalten Sie exklusive Funktionen und Vorteile frei!",
    unlockFeatures: "Erhalten Sie werbefreie Erfahrung, prioritären Support und mehr",
    writeReview: "Bewertung schreiben (30 Tage)",
    inviteFriend: "Freund einladen (1 Jahr)",
    stackingInfo: "Premium-Zeit stapelt sich! Schreibe Bewertungen und lade Freunde ein, um unbegrenzte Zugriffszeit anzusammeln.",
    sources: {
      REVIEW: "Bewertung geschrieben",
      REFERRAL_INVITER: "Freund beigetreten & bewertet",
      REFERRAL_INVITEE: "Per Einladung beigetreten",
    },
    durations: {
      month: "30 Tage",
      year: "1 Jahr",
    },
  },

  // Statistik Dashboard
  statsDashboard: {
    title: "Analytics Dashboard",
    subtitle: "Umfassende Einblicke und Statistiken",
    refresh: "Aktualisieren",
    dateRange: {
      to: "Bis",
      startPlaceholder: "Startdatum",
      endPlaceholder: "Enddatum",
    },
    metrics: {
      totalCourses: "Kurse gesamt",
      totalReviews: "Bewertungen gesamt",
      activeUsers: "Aktive Benutzer",
      avgRating: "Durchschnittsbewertung",
    },
    charts: {
      reviewsOverTime: "Kursbewertungen im Zeitverlauf",
      ratingDistribution: "Bewertungsverteilung",
      universityPerformance: "Universitätsleistung im Vergleich",
      topRatedCourses: "Bestbewertete Kurse",
    },
    timeframes: {
      last7Days: "Letzte 7 Tage",
      last30Days: "Letzte 30 Tage",
      last3Months: "Letzte 3 Monate",
      lastYear: "Letztes Jahr",
    },
    universityMetrics: {
      avgRating: "Durchschn. Bewertung",
      totalReviews: "Bewertungen gesamt",
      totalCourses: "Kurse gesamt",
    },
    activity: {
      title: "Neueste Aktivitäten",
      filters: {
        all: "Alle",
        reviews: "Bewertungen",
        courses: "Kurse",
        users: "Benutzer",
      },
      types: {
        courseAdded: "Neuer Kurs hinzugefügt",
        highRating: "Hohe Bewertung erhalten",
        newUsers: "Neue Benutzerregistrierung",
      },
      timeAgo: {
        minutesAgo: "{count} Minuten her",
        hoursAgo: "{count} Stunden her",
        daysAgo: "{count} Tage her",
      },
    },
    messages: {
      refreshSuccess: "Daten erfolgreich aktualisiert",
      refreshError: "Fehler beim Aktualisieren der Daten",
    },
  },

  // Bewertungen verwalten
  reviewsPage: {
    title: "Meine Bewertungen",
    subtitle: "Verwalten Sie Ihre Kursbewertungen und sehen Sie Ihren Beitrag zur Community",
    stats: {
      totalReviews: "Bewertungen gesamt",
      averageRating: "Durchschnittsbewertung",
      semesters: "Semester",
    },
    card: {
      title: "Ihre Bewertungen",
      searchPlaceholder: "Bewertungen durchsuchen...",
    },
    filters: {
      rating: "Nach Bewertung filtern",
      semester: "Nach Semester filtern",
      sortBy: "Sortieren nach",
      clearFilters: "Filter löschen",
    },
    rating: {
      stars5: "5 Sterne",
      stars4: "4 Sterne",
      stars3: "3 Sterne",
      stars2: "2 Sterne",
      stars1: "1 Stern",
    },
    semester: {
      winter2024: "2024 Winter",
      summer2024: "2024 Sommer",
      winter2023: "2023 Winter",
      summer2023: "2023 Sommer",
      winterFull2024: "Wintersemester 2024",
      summerFull2024: "Sommersemester 2024",
      winterFull2023: "Wintersemester 2023",
      summerFull2023: "Sommersemester 2023",
    },
    sort: {
      newest: "Neueste zuerst",
      oldest: "Älteste zuerst",
      highest: "Höchste Bewertung",
      lowest: "Niedrigste Bewertung",
    },
    empty: {
      title: "Keine Bewertungen gefunden",
      action: "Kurse bewerten",
    },
    actions: {
      edit: "Bearbeiten",
      delete: "Löschen",
    },
    editDialog: {
      title: "Bewertung bearbeiten",
      course: "Kurs",
      rating: "Bewertung",
      semester: "Semester",
      semesterPlaceholder: "Semester auswählen",
      comment: "Kommentar",
      commentPlaceholder: "Bewertung aktualisieren...",
      cancel: "Abbrechen",
      update: "Bewertung aktualisieren",
    },
    ratingTexts: {
      terrible: "Schrecklich",
      bad: "Schlecht",
      average: "Durchschnittlich",
      good: "Gut",
      excellent: "Ausgezeichnet",
    },
    messages: {
      updateSuccess: "Bewertung erfolgreich aktualisiert",
      updateError: "Fehler beim Aktualisieren der Bewertung",
      deleteConfirmTitle: "Bewertung löschen",
      deleteConfirmMessage: "Möchten Sie diese Bewertung wirklich löschen?",
      deleteSuccess: "Bewertung erfolgreich gelöscht",
      deleteError: "Fehler beim Löschen der Bewertung",
    },
  },

  // E-Mail-Verifizierung
  emailVerification: {
    title: "E-Mail-Verifizierung",
    loading: "E-Mail wird verifiziert...",
    success: {
      title: "E-Mail-Verifizierung erfolgreich!",
      message: "Willkommen bei KursKompass! Sie können sich jetzt anmelden und alle Funktionen nutzen.",
      action: "Zur Anmeldung",
    },
    error: {
      title: "Verifizierung fehlgeschlagen",
      action: "Erneut registrieren",
    },
    initial: {
      title: "E-Mail-Verifizierung",
      message: "Bitte überprüfen Sie Ihre E-Mail und klicken Sie auf den Verifizierungslink, um Ihr Konto zu aktivieren.",
    },
    resend: {
      prompt: "Keine E-Mail erhalten?",
      placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
      button: "Erneut senden",
      buttonSending: "Wird gesendet...",
      buttonResend: "Verifizierungs-E-Mail erneut senden",
      success: "Verifizierungs-E-Mail wurde erneut gesendet. Bitte überprüfen Sie Ihren Posteingang.",
      error: "E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
      emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein",
    },
  },

  // Profil-Seite
  profilePage: {
    actions: {
      editProfile: "Profil bearbeiten",
      changePassword: "Passwort ändern",
    },
    tabs: {
      info: "Profilinformationen",
      reviews: "Meine Bewertungen",
      invitations: "Einladungen",
      premium: "Premium-Verlauf",
    },
    premiumStatus: {
      title: "Premium-Status",
      activeTitle: "⭐ Premium-Zugang aktiv",
      inactiveTitle: "Premium-Zugang freischalten",
      activeMessage: "Sie genießen vollen Zugang zu allen Premium-Funktionen!",
      inactiveMessage: "Schreiben Sie Bewertungen oder laden Sie Freunde ein, um Premium-Zugang zu erhalten.",
      expiresOn: "Läuft ab am",
      extendTitle: "Premium-Zeit verlängern",
      extendMessage: "Schreiben Sie weitere Bewertungen oder laden Sie Freunde ein, um Ihre Premium-Zeit zu verlängern!",
      writeReviewButton: "Bewertung schreiben (+30 Tage)",
      inviteFriendButton: "Freund einladen (+1 Jahr)",
      active: "Premium-Zugang aktiv",
      validUntil: "Gültig bis:",
      unlimited: "✓ Unbegrenzter Zugang zu Bewertungen",
    },
    personalInfo: {
      title: "Persönliche Informationen",
      firstName: "Vorname",
      lastName: "Nachname",
      university: "Universität",
      major: "Studiengang",
      graduationYear: "Abschlussjahr",
      username: "Benutzername",
      email: "E-Mail",
      totalReviews: "Bewertungen gesamt",
      notProvided: "Nicht angegeben",
    },
    bio: {
      title: "Über mich",
    },
    reviews: {
      title: "Meine Kursbewertungen",
      stats: {
        total: "Bewertungen gesamt",
        avgRating: "Ø Bewertung",
      },
      empty: "Sie haben noch keine Bewertungen geschrieben",
      sortBy: "Sortieren nach",
      sortOptions: {
        newest: "Neueste zuerst",
        oldest: "Älteste zuerst",
        highest: "Höchste Bewertung",
        lowest: "Niedrigste Bewertung",
      },
      actions: {
        edit: "Bearbeiten",
        delete: "Löschen",
      },
      deleteConfirm: {
        title: "Bewertung löschen",
        message: "Möchten Sie diese Bewertung wirklich löschen?",
      },
    },
    editDialog: {
      title: "Profil bearbeiten",
      sections: {
        personal: "Persönliche Informationen",
        academic: "Akademische Informationen",
        contact: "Kontaktinformationen",
        bio: "Biografie",
      },
      fields: {
        firstName: "Vorname",
        lastName: "Nachname",
        university: "Universität",
        major: "Studiengang",
        graduationYear: "Abschlussjahr",
        email: "E-Mail-Adresse",
        bio: "Biografie",
      },
      placeholders: {
        firstName: "Vorname eingeben",
        lastName: "Nachname eingeben",
        university: "Universität auswählen",
        major: "z.B. Informatik",
        graduationYear: "2025",
        email: "ihre.email{'@'}beispiel.de",
        bio: "Erzählen Sie uns über sich... (optional)",
      },
      current: "Aktuell:",
      displayNamePreference: "Bevorzugte Anzeige des Namens",
      displayName: {
        realname: "Echter Name",
        username: "Benutzername",
        anonymous: "Anonym",
        anonymousDesc: "Als Anonymer Benutzer anzeigen",
      },
      cancel: "Abbrechen",
      save: "Änderungen speichern",
      saveChanges: "Änderungen speichern",
      messages: {
        updateSuccess: "Profil erfolgreich aktualisiert",
        updateError: "Fehler beim Aktualisieren des Profils",
      },
    },
    passwordDialog: {
      title: "Passwort ändern",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort",
      confirmPassword: "Passwort bestätigen",
      cancel: "Abbrechen",
      change: "Passwort ändern",
      messages: {
        success: "Passwort erfolgreich geändert",
        error: "Fehler beim Ändern des Passworts",
      },
    },
    validation: {
      emailRequired: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      yearRequired: "Bitte geben Sie ein gültiges Jahr ein",
      currentPasswordRequired: "Bitte geben Sie Ihr aktuelles Passwort ein",
      newPasswordRequired: "Bitte geben Sie ein neues Passwort ein",
      confirmPasswordRequired: "Bitte geben Sie das Passwort erneut ein",
      passwordMismatch: "Die Passwörter stimmen nicht überein",
    },
  },

  // Universität hinzufügen
  addUniversity: {
    title: "Universität hinzufügen",
    subtitle: "Neue deutsche Universität zur Plattform hinzufügen",
    fields: {
      name: "Universitätsname",
      shortName: "Kurzname",
      city: "Stadt",
      state: "Bundesland",
      type: "Typ",
      established: "Gegründet",
      website: "Webseite",
      description: "Beschreibung",
    },
    placeholders: {
      name: "z.B. Technische Universität München",
      shortName: "z.B. TUM, LMU",
      city: "z.B. München",
      state: "z.B. Bayern",
      type: "Typ auswählen",
      website: "https://www.universitaet.de",
      description: "Kurze Beschreibung der Universität, ihrer Stärken und Besonderheiten",
    },
    types: {
      full: "Volluniversität",
      technical: "Technische Universität",
      applied: "Fachhochschule",
      art: "Kunsthochschule",
      music: "Musikhochschule",
      sport: "Sporthochschule",
    },
    actions: {
      cancel: "Abbrechen",
      submit: "Universität hinzufügen",
    },
    validation: {
      nameRequired: "Bitte geben Sie den Universitätsnamen ein",
      nameLength: "Die Länge sollte zwischen 2 und 200 Zeichen betragen",
      shortNameRequired: "Bitte geben Sie den Kurznamen ein",
      shortNameLength: "Die Länge sollte zwischen 2 und 50 Zeichen betragen",
      cityRequired: "Bitte geben Sie die Stadt ein",
      cityLength: "Die Länge sollte zwischen 2 und 50 Zeichen betragen",
      stateRequired: "Bitte geben Sie das Bundesland ein",
      stateLength: "Die Länge sollte zwischen 2 und 50 Zeichen betragen",
      typeRequired: "Bitte wählen Sie einen Typ aus",
      establishedRequired: "Bitte geben Sie das Gründungsjahr ein",
      websiteInvalid: "Bitte geben Sie eine gültige URL ein",
      descriptionRequired: "Bitte geben Sie eine Beschreibung ein",
      descriptionLength: "Die Länge sollte zwischen 10 und 1000 Zeichen betragen",
    },
    messages: {
      success: "Universität erfolgreich hinzugefügt!",
      error: "Fehler beim Hinzufügen der Universität",
    },
  },

  // Monitoring Dashboard
  monitoring: {
    title: "Such-Service Überwachungsdashboard",
    checking: "Prüfe...",
    refresh: "Daten aktualisieren",
    refreshing: "Aktualisiere...",
    stats: {
      totalSearches: "Gesamtzahl der Suchen",
      avgResponseTime: "Ø Antwortzeit",
      maxResponseTime: "Max. Antwortzeit",
      systemStatus: "Systemstatus",
    },
    popularSearches: {
      title: "Top 10 beliebte Suchen",
      loading: "Lädt...",
      times: "mal",
    },
    errors: {
      loadFailed: "Beliebte Suchen konnten nicht geladen werden",
      refreshFailed: "Datenaktualisierung fehlgeschlagen",
    },
  },

  // Student Verification
  verification: {
    title: "Studentenstatus prüfen",
    verifyCode: "Code prüfen",
    instructions: "Nutzen Sie Ihre Uni-E-Mail zur Bestätigung.",
    universityLabel: "Universität",
    selectUniversity: "Universität wählen",
    universityRequired: "Universität erforderlich",
    selectUniversityFirst: "Bitte zuerst Universität wählen",
    loadingDomains: "Domains werden geladen...",
    emailLabel: "Uni-E-Mail",
    emailCalloutTitle: "Uni-E-Mail",
    emailCalloutSubtitle: "Nur erlaubte Domains sind zulässig.",
    emailPlaceholder: "student{'@'}tum.de",
    emailRequired: "E-Mail erforderlich",
    emailInvalid: "Ungültige E-Mail",
    validDomains: "Gültige Domains",
    validDomainHint: "Diese Domain ist zugelassen: {domain}",
    invalidDomainHint: "Diese Domain ist noch nicht hinterlegt. Bitte gib dem Team Bescheid.",
    unknownDomainHint: "Wir konnten diese Domain nicht zuordnen. Bitte prüfe deine Adresse.",
    sendCode: "Code senden",
    codeLabel: "Prüfcode",
    codePlaceholder: "Sechsstelliger Code",
    codeRequired: "Code erforderlich",
    codeLength: "Code muss sechs Ziffern haben",
    verify: "Prüfen",
    resendCode: "Code erneut senden",
    resendIn: "Erneut senden in {seconds} Sekunden",
    codeSent: "Code gesendet an {email}",
    successTitle: "Bestätigung abgeschlossen",
    successMessage: "Status bestätigt.",
    codeSentSuccess: "Code erfolgreich gesendet",
    verifySuccess: "Erfolgreich bestätigt",
    resendSuccess: "Code erneut gesendet",
    loadUniversitiesError: "Universitäten konnten nicht geladen werden",
    sendCodeError: "Code konnte nicht gesendet werden",
    verifyError: "Bestätigung fehlgeschlagen",
    resendError: "Erneutes Senden fehlgeschlagen",
    verifiedStudent: "Bestätigter Student",
    verifyStudentStatus: "Studentenstatus prüfen",
  },

  // User preview card
  userPreview: {
    reviews: "Bewertungen",
    followers: "Follower",
    likes: "Likes",
    message: "Nachricht",
    viewProfile: "Profil ansehen",
    loadFailed: "Benutzerinformationen konnten nicht geladen werden",
  },

  // User profile page
  userProfile: {
    overview: "Übersicht",
    reviews: "Bewertungen",
    activity: "Aktivität",
    bio: "Biografie",
    major: "Hauptfach",
    graduationYear: "Abschlussjahr",
    joinedDate: "Beigetreten",
    followersCount: "Follower",
    followingCount: "Folgt",
    reviewsCount: "Bewertungen",
    totalUpvotes: "Gesamte Likes",
    likes: "Likes",
    noBio: "Dieser Benutzer hat noch keine Biografie geschrieben.",
    noBioOwn: "Sie haben noch keine Biografie geschrieben. Klicken Sie auf 'Bio hinzufügen', um sich vorzustellen!",
    noReviews: "Noch keine Bewertungen.",
    loadError: "Benutzerprofil konnte nicht geladen werden",
    courseName: "Kurs",
    semester: "Semester",
    viewCourse: "Kurs ansehen",
    editBio: "Bio bearbeiten",
    addBio: "Bio hinzufügen",
    bioPlaceholder: "Erzählen Sie anderen von sich...",
    bioUpdateSuccess: "Bio erfolgreich aktualisiert",
    bioUpdateFailed: "Bio konnte nicht aktualisiert werden",
    verifiedStudent: "Verifizierter Student",
  },

  // Bewertungsfilter
  reviewFilter: {
    title: "Bewertungen filtern & sortieren",
    clearAll: "Alle löschen",
    rating: "Bewertung",
    anyRating: "Alle Bewertungen",
    star: "Stern | Sterne",
    semester: "Semester",
    anySemester: "Alle Semester",
    sortBy: "Sortieren nach",
    mostRecent: "Neueste",
    highestRating: "Höchste Bewertung",
    lowestRating: "Niedrigste Bewertung",
    mostHelpful: "Hilfreichste",
    searchReviews: "Bewertungen durchsuchen",
    searchPlaceholder: "In Bewertungskommentaren suchen...",
    reviewLength: "Bewertungslänge",
    anyLength: "Beliebige Länge",
    shortReviews: "Kurze Bewertungen (< 100 Zeichen)",
    mediumReviews: "Mittlere Bewertungen (100-300 Zeichen)",
    longReviews: "Lange Bewertungen (> 300 Zeichen)",
    verifiedStudents: "Verifizierte Studenten",
    onlyVerified: "Nur Verifizierte",
    allReviews: "Alle Bewertungen",
    hide: "Ausblenden",
    show: "Anzeigen",
    advancedFilters: "Erweiterte Filter",
    activeFilters: "Aktive Filter",
    verifiedStudentsOnly: "Nur verifizierte Studenten",
  },

  // Kursseite
  coursesPage: {
    title: "Kursentdeckung",
    subtitle: "Entdecken Sie Kurse mit unserem erweiterten Such- und Filtersystem",
    universityTip: "💡 Wählen Sie Ihre Universität in den Suchfiltern unten aus, um personalisierte Kursempfehlungen zu erhalten",
    addCourseHint: "Können Sie Ihren Kurs nicht finden? Fügen Sie ihn hinzu und teilen Sie Ihre erste Bewertung!",
    addCourse: "Kurs hinzufügen",
    coursesFound: "{count} Kurse gefunden",
    showingResults: "Ergebnisse für Ihre Suche und Filter anzeigen",
    grid: "Raster",
    list: "Liste",
    noCourses: "Keine Kurse gefunden",
    noCoursesDescription: "Keine Kurse gefunden, die Ihren Kriterien entsprechen",
    noCoursesSubtitle: "Versuchen Sie, Ihre Suchfilter anzupassen, oder schauen Sie sich den obigen Hinweis an, um einen neuen Kurs hinzuzufügen!",
    clearFilters: "Filter löschen",
    courseCode: "Kurscode",
    viewDetails: "Details ansehen",
    viewReviews: "Bewertungen ansehen",
  },

  // Bewertungsstatistiken
  reviewStats: {
    title: "Bewertungsstatistiken",
    reviewsCount: "{count} Bewertungen",
    ratingDistribution: "Bewertungsverteilung",
    averageRating: "Durchschnittsbewertung",
    totalReviews: "Gesamtbewertungen",
    recommend: "Empfehlen",
    overallRating: "Gesamtbewertung",
    courseCharacteristics: "Kursmerkmale",
    difficulty: "Schwierigkeit",
    workload: "Arbeitsaufwand",
    teaching: "Lehre",
    courseRatingQuality: "Kursbewertungsqualität",
    difficultyLabels: {
      veryEasy: "Sehr einfach",
      easy: "Einfach",
      moderate: "Moderat",
      challenging: "Herausfordernd",
      veryChallenging: "Sehr herausfordernd",
    },
    workloadLabels: {
      veryLight: "Sehr leicht",
      light: "Leicht",
      moderate: "Moderat",
      heavy: "Schwer",
      veryHeavy: "Sehr schwer",
    },
    teachingLabels: {
      poor: "Schlecht",
      fair: "Ausreichend",
      good: "Gut",
      veryGood: "Sehr gut",
      excellent: "Ausgezeichnet",
    },
    qualityLabels: {
      excellent: "Ausgezeichnet",
      veryGood: "Sehr gut",
      good: "Gut",
      average: "Durchschnittlich",
      belowAverage: "Unterdurchschnittlich",
      poor: "Schlecht",
    },
    qualityDescriptions: {
      excellent: "Dieser Kurs erhält durchgehend hervorragende Bewertungen von Studenten.",
      veryGood: "Dieser Kurs wird von den meisten Studenten hoch bewertet und empfohlen.",
      good: "Dieser Kurs erhält im Allgemeinen positives Feedback von Studenten.",
      average: "Dieser Kurs erhält gemischte Bewertungen von Studenten.",
      belowAverage: "Dieser Kurs hat überwiegend negatives Feedback von Studenten erhalten.",
      poor: "Dieser Kurs hat laut Studentenfeedback erhebliche Probleme.",
    },
  },
};
